import React from "react";
import _ from "lodash";

type Props = {
    src: string;
    alt: string;
    width: number;
    height: number;
    originalWidth: number;
    originalHeight: number;
    sizes: string;
    widths: number[];
};

type SrcProps = {
    url: string;
    width: number;
    height: number;
    fit?: string;
}

const src = (props: SrcProps) => {
    const params = [
        `height=${props.height}`,
        `width=${props.width}`,
        `fit=crop`,
        `metadata=copyright`,
    ];

    if (_.startsWith(props.url, "https://imagedelivery.net/")) {
        return `${props.url}/${params.join(",")} ${props.width}w`;
    }
    return `https://tacboard.com/cdn-cgi/image/${params.join(",")}/${props.url} ${props.width}w`;
}

const Pic = (props: Props) => {
    let srcWidths = [];

    props.widths.forEach((w: number) => {
        srcWidths.push(w);
        if (2*w < props.width) {
            srcWidths.push(2*w);
        }
    });
    srcWidths = _.uniq(srcWidths);

    const srcSet = srcWidths.map((w: number) => {
        const scale = w / props.width;
        return src({
            url: props.src,
            width: w,
            height: Math.round(scale * props.height),
        });
    });
 
    return (
        <img
            src={props.src}
            alt={props.alt}
            width={props.width}
            height={props.height}
            sizes={props.sizes}
            srcSet={srcSet.join(",")}
        />
    );
};

export default Pic;
